"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getScrollLeftOfDom = exports.getScrollTopOfDom = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _spauiPortal = _interopRequireDefault(require("@tencent/spaui-portal"));

var _spauiIcon = _interopRequireDefault(require("@tencent/spaui-icon"));

var _classnames = _interopRequireDefault(require("classnames"));

var _odAnimate = _interopRequireDefault(require("@tencent/od-animate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// 弹框宽度
var dialogWidthMap = {
  small: 320,
  middle: 400,
  large: 600,
  extraLarge: 800,
  xl: 800,
  xxl: 1000,
  xxxl: 1200
}; // 是否有jQuery

var haveJQuery = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && typeof window.jQuery === 'function'; // 转化成int

var toInt = function toInt() {
  var intValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return parseInt(intValue, 10) || defaultValue;
}; // 获取window窗口的宽高


var getWindowSize = function getWindowSize() {
  var windowHeight = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && window.innerHeight;
  var windowWidth = Math.max((typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.body.offsetWidth, (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && window.innerWidth, (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.body.scrollWidth);
  return {
    windowWidth: windowWidth,
    windowHeight: windowHeight
  };
}; // 获取页面的内容宽高


var getDocumentSize = function getDocumentSize() {
  var documentWidth = Math.max((typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.body.offsetWidth, (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && window.innerWidth, (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.body.scrollWidth);
  var documentHeight = Math.max((typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.body.offsetHeight, (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && window.innerHeight, (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.body.scrollHeight);
  return {
    documentWidth: documentWidth,
    documentHeight: documentHeight
  };
}; // 获取对应结构的scrollTop;


var getScrollTopOfDom = function getScrollTopOfDom(target) {
  var result = 0;

  if (target) {
    result = target.scrollTop;

    if (result < 1 && haveJQuery) {
      result = jQuery(target).scrollTop();
    }
  } else {
    if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object') {
      result = document.getElementsByTagName('html')[0].scrollTop || document.getElementsByTagName('body')[0].scrollTop;
    }

    if (result < 1 && haveJQuery) {
      result = jQuery('html').scrollTop() || jQuery('body').scrollTop();
    }
  }

  return result;
}; // 获取对应结构的scrollLeft;


exports.getScrollTopOfDom = getScrollTopOfDom;

var getScrollLeftOfDom = function getScrollLeftOfDom(target) {
  var result = 0;

  if (target) {
    result = target.scrollLeft;

    if (result < 1 && haveJQuery) {
      result = jQuery(target).scrollLeft();
    }
  } else {
    if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object') {
      result = document.getElementsByTagName('html')[0].scrollLeft || document.getElementsByTagName('body')[0].scrollLeft;
    }

    if (result < 1 && haveJQuery) {
      result = jQuery('html').scrollLeft() || jQuery('body').scrollLeft();
    }
  }

  return result;
};
/**
 * @class
 */


exports.getScrollLeftOfDom = getScrollLeftOfDom;

var DOMComponent =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(DOMComponent, _PureComponent);

  function DOMComponent(props) {
    var _this;

    _classCallCheck(this, DOMComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DOMComponent).call(this, props));

    _this.nullList();

    _this.isClickDialog = false;
    _this.handleClickModal = _this.handleClickModal.bind(_assertThisInitialized(_this));
    _this.setDialogStyle = _this.setDialogStyle.bind(_assertThisInitialized(_this));
    _this.setIsClickDialog = _this.setIsClickDialog.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DOMComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setPositionAndListenResize();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setPositionAndListenResize();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.nullList();
      this.removeListenResize();
      this.removeBodyOverflowHiddenClassName();
    }
  }, {
    key: "nullList",
    value: function nullList() {
      this.dialog = null;
      this.content = null;
      this.modal = null;
    } // 设置弹框位置并监听窗口resize

  }, {
    key: "setPositionAndListenResize",
    value: function setPositionAndListenResize() {
      var _this$props = this.props,
          position = _this$props.position,
          show = _this$props.show; // 如果关闭样式就不需要设置位置了

      if (position !== 'close') {
        this.setDialogStyle(); // 展示的时候设置监听，关闭的时候去除监听

        if (show && !this.haveAddWindowResize) {
          if (haveJQuery) {
            jQuery(window).on('resize', this.setDialogStyle);
          } else if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && (0, _spauiUtils.isFunction)(window.addEventListener)) {
            window.addEventListener('resize', this.setDialogStyle);
          }

          this.haveAddWindowResize = true;
        } else if (!show) {
          this.removeListenResize();
        }
      }
    } // 去除监听

  }, {
    key: "removeListenResize",
    value: function removeListenResize() {
      if (this.haveAddWindowResize) {
        if (haveJQuery) {
          jQuery(window).off('resize', this.setDialogStyle);
        } else if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && (0, _spauiUtils.isFunction)(window.addEventListener)) {
          window.removeEventListener('resize', this.setDialogStyle);
        }

        this.haveAddWindowResize = false;
      }
    }
  }, {
    key: "haveEventTarget",
    value: function haveEventTarget() {
      var eventTarget = this.props.eventTarget;
      return _typeof(eventTarget) === 'object' && eventTarget && eventTarget.getBoundingClientRect;
    } // 获取跟随弹框的位置参数

  }, {
    key: "getEventTargetDialogPosition",
    value: function getEventTargetDialogPosition(dialogWidth, dialogHeight, winWidth, winHeight) {
      var _this$props2 = this.props,
          eventTargetPlacement = _this$props2.eventTargetPlacement,
          eventTarget = _this$props2.eventTarget,
          eventTargetLeftDeviation = _this$props2.eventTargetLeftDeviation,
          eventTargetTopDeviation = _this$props2.eventTargetTopDeviation,
          eventTargetPosition = _this$props2.eventTargetPosition;
      var dialogLeft = 0;
      var dialogTop = 0;
      var eventTargetRect = {};
      var eventTargetRectLeft = 0;
      var eventTargetRectTop = 0;
      var eventTargetRectHeight = 0;
      var eventTargetRectWidth = 0; // 如果传了dom节点，就用dom节点的位置

      if (this.haveEventTarget()) {
        eventTargetRect = eventTarget.getBoundingClientRect();
        eventTargetRectLeft = eventTargetRect.left || 0;
        eventTargetRectTop = eventTargetRect.top || 0;
        eventTargetRectHeight = eventTargetRect.height || 0;
        eventTargetRectWidth = eventTargetRect.width || 0; // 也可以直出对应的位置
      } else if (_typeof(eventTargetPosition) === 'object' && eventTargetPosition) {
        eventTargetRectLeft = eventTargetPosition.left || 0;
        eventTargetRectTop = eventTargetPosition.top || 0;
        eventTargetRectHeight = eventTargetPosition.height || 0;
        eventTargetRectWidth = eventTargetPosition.width || 0;
      }

      switch (eventTargetPlacement) {
        case 'top':
          dialogLeft = eventTargetRectLeft;
          dialogTop = eventTargetRectTop - dialogHeight;
          break;

        case 'left':
          dialogLeft = eventTargetRectLeft - dialogWidth;
          dialogTop = eventTargetRectTop + eventTargetRectHeight;
          break;

        case 'right':
          dialogLeft = eventTargetRectLeft + eventTargetRectWidth;
          dialogTop = eventTargetRectTop + eventTargetRectHeight;
          break;

        case 'auto':
          dialogLeft = eventTargetRectLeft;
          dialogTop = eventTargetRectTop + eventTargetRectHeight;

          if (dialogLeft + dialogWidth > winWidth) {
            dialogLeft = eventTargetRectLeft - dialogWidth;
          }

          if (dialogTop + dialogHeight > winHeight) {
            dialogTop = eventTargetRectTop - dialogHeight;
          }

          break;

        default:
          dialogLeft = eventTargetRectLeft;
          dialogTop = eventTargetRectTop + eventTargetRectHeight;
          break;
      } // 减去弹框本身的边距再加上偏差


      dialogLeft = dialogLeft - toInt((0, _spauiUtils.getStyle)(this.dialog, 'marginLeft')) + toInt(eventTargetLeftDeviation);
      dialogTop = dialogTop - toInt((0, _spauiUtils.getStyle)(this.dialog, 'marginTop')) + toInt(eventTargetTopDeviation);
      return {
        left: dialogLeft,
        top: dialogTop
      };
    }
  }, {
    key: "removeBodyOverflowHiddenClassName",
    value: function removeBodyOverflowHiddenClassName() {
      var body = (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.getElementsByTagName('body')[0];
      var bodyClassName = body.className || '';
      var overflowHiddenClassName = 'spaui-overflow-hidden';
      var bodyClassNameList = bodyClassName.split(' ');
      var index = -1; // 如果已经设置过，隐藏的时候进行回收

      if (this.addBodyOverflowHiddenClassName) {
        index = (0, _spauiUtils.indexOf)(bodyClassNameList, overflowHiddenClassName);

        if (index > -1) {
          bodyClassNameList.splice(index, 1);
          this.addBodyOverflowHiddenClassName = false;
        }
      }

      body.className = bodyClassNameList.join(' ');
    } // 根据需要设置body的classname

  }, {
    key: "setBodyOverflowHiddenClassName",
    value: function setBodyOverflowHiddenClassName() {
      var _this$props3 = this.props,
          show = _this$props3.show,
          hideScrollBar = _this$props3.hideScrollBar;
      var body = (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.getElementsByTagName('body')[0];
      var bodyClassName = body.className || '';
      var overflowHiddenClassName = 'spaui-overflow-hidden';
      var bodyClassNameList = bodyClassName.split(' ');

      if (show) {
        // 展示的时候，需要以及还没设置隐藏滚动条的classname
        if (hideScrollBar && !this.addBodyOverflowHiddenClassName) {
          bodyClassNameList.push(overflowHiddenClassName);
          this.addBodyOverflowHiddenClassName = true;
        }

        body.className = bodyClassNameList.join(' ');
      } else {
        this.removeBodyOverflowHiddenClassName();
      }
    } // 设置弹框的样式位置

  }, {
    key: "setDialogStyle",
    value: function setDialogStyle() {
      var _this$props4 = this.props,
          size = _this$props4.size,
          show = _this$props4.show,
          _this$props4$style = _this$props4.style,
          style = _this$props4$style === void 0 ? {} : _this$props4$style,
          topSpace = _this$props4.topSpace,
          bottomSpace = _this$props4.bottomSpace,
          _this$props4$classNam = _this$props4.className,
          className = _this$props4$classNam === void 0 ? '' : _this$props4$classNam,
          _this$props4$position = _this$props4.position,
          position = _this$props4$position === void 0 ? '' : _this$props4$position,
          hideScrollBar = _this$props4.hideScrollBar,
          eventTargetPosition = _this$props4.eventTargetPosition,
          eventTargetLeftDeviation = _this$props4.eventTargetLeftDeviation,
          eventTargetTopDeviation = _this$props4.eventTargetTopDeviation,
          eventTargetIsFixed = _this$props4.eventTargetIsFixed,
          useNewUI = _this$props4.useNewUI;

      var _getWindowSize = getWindowSize(),
          windowWidth = _getWindowSize.windowWidth,
          windowHeight = _getWindowSize.windowHeight;

      var _getDocumentSize = getDocumentSize(),
          documentWidth = _getDocumentSize.documentWidth,
          documentHeight = _getDocumentSize.documentHeight;

      var contentRect = {};
      var dialogWidth = toInt(style.width);
      var dialogHeight = 0;
      var eventTargetDialogPosition = {}; // 先重置下modal的overflow，避免有滚动条计算不正确

      if (this.modal) {
        this.modal.style.overflow = '';
      } // 根据需要设置classname


      this.setBodyOverflowHiddenClassName();
      if (!show) return;

      if (useNewUI) {
        // 设置弹框的最大高度，如果 body 内容过多，滚动区域仅限弹框的 body
        if (show && this.dialog && this.content) {
          this.content.style.maxHeight = "".concat(windowHeight - 20, "px");
        }
      }

      if (show && this.dialog && this.content) {
        // 如果指定了宽度就设置下
        contentRect = this.content.getBoundingClientRect();

        if (dialogWidth) {
          this.content.style.width = "".concat(dialogWidth, "px");
        } else if (size && dialogWidthMap[size]) {
          dialogWidth = Math.max(dialogWidthMap[size], contentRect.width || 0);
          this.content.style.width = "".concat(dialogWidth, "px");
        } else if (contentRect.width > 0) {
          // 内容区域的样式
          dialogWidth = contentRect.width;
          this.dialog.style.width = "".concat(contentRect.width, "px");
        } // 弹框高度


        if (className.indexOf('with-full-height') > -1) {
          dialogHeight = windowHeight;
        } else {
          dialogHeight = Math.max(toInt(style.height), contentRect.height);
        }
      }

      if (this.dialog && this.modal) {
        // 指定了跟随
        if (this.haveEventTarget() || _typeof(eventTargetPosition) === 'object' && eventTargetPosition || eventTargetLeftDeviation || eventTargetTopDeviation) {
          eventTargetDialogPosition = this.getEventTargetDialogPosition(dialogWidth, dialogHeight, windowWidth, windowHeight);
          this.dialog.style.left = "".concat(eventTargetDialogPosition.left, "px");
          this.dialog.style.top = "".concat(eventTargetDialogPosition.top, "px"); // 开启了滚动条，就用absolute贴在对应的位置

          if (this.haveEventTarget() && !hideScrollBar && !eventTargetIsFixed) {
            this.modal.style.position = 'absolute';

            if (documentWidth === window.innerWidth) {
              this.modal.style.width = '100%';
            } else {
              this.modal.style.width = "".concat(documentWidth, "px");
            }

            if (documentHeight === window.innerHeight) {
              this.modal.style.height = '100%';
            } else {
              this.modal.style.height = "".concat(documentHeight, "px");
            }

            this.dialog.style.left = "".concat(eventTargetDialogPosition.left + getScrollLeftOfDom(), "px");
            this.dialog.style.top = "".concat(eventTargetDialogPosition.top + getScrollTopOfDom(), "px");
          }
        } else {
          if (!useNewUI) {
            // 指定了位置
            if (position === 'right') {
              this.dialog.style.right = '0px';
              this.dialog.style.marginRight = '0px';
            } else {
              this.dialog.style.left = '50%';
              this.dialog.style.marginLeft = "".concat(-dialogWidth / 2, "px");
            } // 弹框高度大于窗口高度就要有滚动条了


            if (dialogHeight > windowHeight) {
              this.dialog.style.position = 'absolute'; // 预留了点跟最上面的边距

              this.dialog.style.top = "".concat(topSpace, "px");
              this.dialog.style.marginTop = 0; // 弹框高度大于窗口了，就要运动条了

              this.modal.style.overflow = 'auto';
            } else {
              if (position === 'absolute') {
                this.dialog.style.position = 'absolute';
                this.modal.style.overflow = 'auto';
              } else {
                this.dialog.style.position = 'fixed';
              }

              if (position === 'top') {
                this.dialog.style.top = "".concat(topSpace, "px");
                this.dialog.style.marginTop = 0;
              } else if (position === 'bottom') {
                this.dialog.style.bottom = "".concat(bottomSpace, "px");
                this.dialog.style.marginTop = 0;
              } else {
                this.dialog.style.top = '50%';
                this.dialog.style.marginTop = "".concat(-dialogHeight / 2, "px");
              }
            }
          }
        }
      }
    } // 点击遮罩层

  }, {
    key: "handleClickModal",
    value: function handleClickModal(event) {
      var _this$props5 = this.props,
          onClose = _this$props5.onClose,
          enabledBackdropClose = _this$props5.enabledBackdropClose,
          backdrop = _this$props5.backdrop; // 只有开启遮罩层点击才会响应onClose

      if (enabledBackdropClose && backdrop !== 'static' && !this.isClickDialog && ((0, _spauiUtils.isFunction)(onClose) || (0, _spauiUtils.isAsyncFunction)(onClose))) {
        onClose(event);
      }

      this.isClickDialog = false;
    } // 获取尾部结构

  }, {
    key: "getFooterDom",
    value: function getFooterDom() {
      var _this$props6 = this.props,
          hideFooter = _this$props6.hideFooter,
          onSubmit = _this$props6.onSubmit,
          onCancel = _this$props6.onCancel,
          FooterComponent = _this$props6.FooterComponent,
          type = _this$props6.type,
          footerClassName = _this$props6.footerClassName,
          footerStyle = _this$props6.footerStyle,
          FooterLeftComponent = _this$props6.FooterLeftComponent,
          FooterRightComponent = _this$props6.FooterRightComponent,
          footerRightPosition = _this$props6.footerRightPosition,
          useNewUI = _this$props6.useNewUI,
          hideFooterDivider = _this$props6.hideFooterDivider;
      var result = null;
      var footerContentDOM = null; // 尾部

      if (!hideFooter && type !== 'tip') {
        if (useNewUI) {
          var hasCustomFooter = typeof FooterComponent !== 'undefined';
          var hasLeftContent = typeof FooterLeftComponent !== 'undefined';

          if (hasCustomFooter) {
            // 自定义 Footer 结构
            footerContentDOM = _react["default"].createElement(FooterComponent, this.props);
          } else if (hasLeftContent) {
            // 如果自定义了左边的结构，那尾部就是左右两边的结构，并且左右两边的组件结构既支持组件也支持实例化后的内容
            footerContentDOM = [_react["default"].createElement("div", {
              className: "spaui-dialog-footer-inner spaui-dialog-left",
              key: "modalfooterleft"
            }, (0, _spauiUtils.isReactNode)(FooterLeftComponent) ? FooterLeftComponent : _react["default"].createElement(FooterLeftComponent, _extends({}, this.props, {
              onCancel: onCancel,
              onSubmit: onSubmit
            }))), _react["default"].createElement("div", {
              className: "spaui-dialog-footer-inner spaui-dialog-right",
              key: "modalfooterright"
            }, (0, _spauiUtils.isReactNode)(FooterRightComponent) ? FooterRightComponent : _react["default"].createElement(FooterRightComponent, _extends({}, this.props, {
              onCancel: onCancel,
              onSubmit: onSubmit
            })))];
          } else {
            // 只有右边的情况，根据 footerRightPosition 属性决定是在中间还是右边
            footerContentDOM = _react["default"].createElement("div", {
              className: (0, _classnames["default"])('spaui-dialog-footer-inner', _defineProperty({}, "spaui-dialog-".concat(footerRightPosition), true))
            }, (0, _spauiUtils.isReactNode)(FooterRightComponent) ? FooterRightComponent : _react["default"].createElement(FooterRightComponent, _extends({}, this.props, {
              onCancel: onCancel,
              onSubmit: onSubmit
            })));
          }

          result = _react["default"].createElement("div", {
            className: (0, _classnames["default"])('spaui-dialog-footer', footerClassName, {
              'has-left': hasLeftContent,
              'no-divider': hideFooterDivider
            }),
            style: footerStyle
          }, footerContentDOM);
        } else {
          // 如果自定义了Footer结构，那就优先用自定义的
          if (typeof FooterComponent !== 'undefined') {
            result = _react["default"].createElement("div", {
              className: (0, _classnames["default"])('modal-footer', footerClassName),
              style: footerStyle
            }, _react["default"].createElement(FooterComponent, this.props));
          } else {
            // 定制左尾部的结构
            if (typeof FooterLeftComponent !== 'undefined') {
              // 如果自定义了左边的结构，那尾部就是左右两边的结构，并且左右两边的组件结构既支持组件也支持实例化后的内容
              footerContentDOM = _react["default"].createElement("div", {
                className: "modal-footer-inner"
              }, _react["default"].createElement("div", {
                className: "modal-footer-left",
                key: "modalfooterleft"
              }, (0, _spauiUtils.isReactNode)(FooterLeftComponent) ? FooterLeftComponent : _react["default"].createElement(FooterLeftComponent, _extends({}, this.props, {
                onCancel: onCancel,
                onSubmit: onSubmit
              }))), _react["default"].createElement("div", {
                className: "modal-footer-right",
                key: "modalfooterright"
              }, (0, _spauiUtils.isReactNode)(FooterRightComponent) ? FooterRightComponent : _react["default"].createElement(FooterRightComponent, _extends({}, this.props, {
                onCancel: onCancel,
                onSubmit: onSubmit
              }))));
            } else {
              // 只有右边的情况
              if ((0, _spauiUtils.isReactNode)(FooterRightComponent)) {
                footerContentDOM = FooterRightComponent;
              } else {
                footerContentDOM = _react["default"].createElement(FooterRightComponent, _extends({}, this.props, {
                  onCancel: onCancel,
                  onSubmit: onSubmit
                }));
              }
            }

            result = _react["default"].createElement("div", {
              className: (0, _classnames["default"])('modal-footer', footerClassName),
              style: footerStyle
            }, footerContentDOM);
          }
        }
      }

      return result;
    }
  }, {
    key: "setIsClickDialog",
    value: function setIsClickDialog() {
      this.isClickDialog = true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props7 = this.props,
          hideHeader = _this$props7.hideHeader,
          show = _this$props7.show,
          backdrop = _this$props7.backdrop,
          subTitle = _this$props7.subTitle,
          iconType = _this$props7.iconType,
          HeaderComponent = _this$props7.HeaderComponent,
          type = _this$props7.type,
          contentClassName = _this$props7.contentClassName,
          contentStyle = _this$props7.contentStyle,
          modalClassName = _this$props7.modalClassName,
          _this$props7$uncover = _this$props7.uncover,
          uncover = _this$props7$uncover === void 0 ? false : _this$props7$uncover,
          modalStyle = _this$props7.modalStyle,
          portalClassName = _this$props7.portalClassName,
          headerClassName = _this$props7.headerClassName,
          headerStyle = _this$props7.headerStyle,
          Dialog = _this$props7.Dialog,
          originProps = _this$props7.originProps,
          _this$props7$position = _this$props7.position,
          position = _this$props7$position === void 0 ? '' : _this$props7$position,
          _this$props7$animatio = _this$props7.animation,
          animation = _this$props7$animatio === void 0 ? false : _this$props7$animatio,
          BodyComponent = _this$props7.BodyComponent,
          useNewUI = _this$props7.useNewUI,
          transitionName = _this$props7.transitionName,
          closeButton = _this$props7.closeButton,
          onClose = _this$props7.onClose,
          _this$props7$closeBut = _this$props7.closeButtonProps,
          closeButtonProps = _this$props7$closeBut === void 0 ? {} : _this$props7$closeBut,
          className = _this$props7.className,
          size = _this$props7.size,
          animationName = _this$props7.animationName,
          eventTarget = _this$props7.eventTarget,
          zIndex = _this$props7.zIndex;
      var transName = !eventTarget ? transitionName : 'nope';
      var styleObj = zIndex ? {
        zIndex: zIndex
      } : {};

      if (useNewUI) {
        return _react["default"].createElement(_spauiPortal["default"], {
          className: (0, _classnames["default"])('spaui-dialog-portal', {
            'has-event-target': eventTarget
          }, portalClassName)
        }, backdrop ? _react["default"].createElement(_odAnimate["default"], {
          transitionName: "".concat(transName, "-mask"),
          component: ""
        }, show ? _react["default"].createElement("div", {
          className: "spaui-dialog-mask",
          style: _objectSpread({}, styleObj)
        }) : null) : null, _react["default"].createElement(_odAnimate["default"], {
          transitionName: transName,
          component: ""
        }, show ? _react["default"].createElement("div", {
          className: "spaui-dialog-inner",
          tabIndex: -1,
          role: "dialog",
          onClick: this.handleClickModal,
          style: _objectSpread({}, modalStyle, {}, styleObj),
          ref: function ref(el) {
            _this2.modal = el;
          }
        }, _react["default"].createElement("div", _extends({}, (0, _spauiUtils.globalProps)(this.props, Dialog, originProps), {
          className: (0, _classnames["default"])('spaui-dialog spaui-dialog-new', className),
          role: "document",
          ref: function ref(el) {
            _this2.dialog = el;
          }
        }), _react["default"].createElement("div", {
          tabIndex: 0,
          "aria-hidden": "true",
          style: {
            width: 0,
            height: 0,
            overflow: 'hidden'
          }
        }), _react["default"].createElement("div", {
          className: (0, _classnames["default"])('spaui-dialog-content', contentClassName),
          onClick: this.setIsClickDialog,
          onMouseDown: this.setIsClickDialog,
          onMouseUp: this.setIsClickDialog,
          style: _objectSpread({
            width: dialogWidthMap[size]
          }, contentStyle),
          ref: function ref(el) {
            _this2.content = el;
          }
        }, _react["default"].createElement("div", {
          className: "spaui-dialog-system"
        }, closeButton ? _react["default"].createElement("button", _extends({
          className: "spaui-dialog-close",
          type: "button",
          "aria-label": "Close",
          onClick: onClose
        }, closeButtonProps), _react["default"].createElement("span", {
          className: "spaui-dialog-close-x"
        }, _react["default"].createElement("i", {
          className: "spaui-dialog-close-icon",
          "aria-label": "close"
        }, _react["default"].createElement(_spauiIcon["default"], {
          name: "close-medium-outlined",
          width: 14,
          height: 14
        })))) : null), !hideHeader && type !== 'tip' ? _react["default"].createElement(HeaderComponent, this.props) : null, _react["default"].createElement(BodyComponent, this.props), this.getFooterDom()))) : null));
      } // 没展示就隐藏


      if (!show) {
        return null;
      }

      return _react["default"].createElement(_spauiPortal["default"], {
        className: "".concat(portalClassName, " spaui-dialog-portal")
      }, backdrop ? _react["default"].createElement("div", {
        className: "modal-backdrop fade in",
        style: _objectSpread({}, styleObj)
      }) : null, _react["default"].createElement("div", {
        className: (0, _classnames["default"])(modalClassName, {
          'fade in modal': position !== 'close',
          'no-cover': uncover && position !== 'right',
          'modal-un-fixed': uncover && position === 'right',
          show: show
        }),
        style: _objectSpread({}, modalStyle, {}, styleObj),
        onClick: this.handleClickModal,
        ref: function ref(el) {
          _this2.modal = el;
        }
      }, _react["default"].createElement("div", _extends({}, (0, _spauiUtils.globalProps)(this.props, {
        className: position === 'right' && animation ? "".concat(animationName, "Right-enter-active") : ''
      }, Dialog, originProps), {
        title: "",
        ref: function ref(el) {
          _this2.dialog = el;
        },
        onClick: this.setIsClickDialog,
        onMouseDown: this.setIsClickDialog,
        onMouseUp: this.setIsClickDialog
      }), _react["default"].createElement("div", {
        className: (0, _classnames["default"])('modal-content spaui-dialog-content', contentClassName, {
          'spaui-dialog-confirm-iconin': type === 'normal' && iconType
        }),
        ref: function ref(el) {
          _this2.content = el;
        },
        style: contentStyle
      }, !hideHeader && type !== 'tip' ? _react["default"].createElement("div", {
        className: (0, _classnames["default"])('modal-header', headerClassName, {
          'with-modal-sub-title': subTitle || typeof subTitle === 'number'
        }),
        style: headerStyle
      }, _react["default"].createElement(HeaderComponent, this.props)) : null, _react["default"].createElement(BodyComponent, this.props), this.getFooterDom()))));
    }
  }]);

  return DOMComponent;
}(_react.PureComponent);

var _default = DOMComponent;
exports["default"] = _default;